import React from 'react';
import { formatDisplayDate } from '../../../utils/formatDisplayDate';
import styles from './subscriptionInfo.module.scss';

interface SubscriptionInfoProps {
  clientOrgName?: string;
  expiresAt?: string;
}

const SubscriptionInfo: React.FC<SubscriptionInfoProps> = ({ clientOrgName, expiresAt }) => (
  <section className={styles.section} aria-labelledby="profile-subscription-info">
    <h2 className={styles.heading} id="profile-subscription-info">
      Subscription
    </h2>

    <p className={styles.summary}>
      You have access to the <span className={styles.link}>{clientOrgName ?? '—'}</span> client portal until{' '}
      <span className={styles.link}>{expiresAt ? formatDisplayDate(expiresAt) : '—'}</span>.
    </p>

    <p className={styles.contact}>
      To learn more about our subscription options or to request an extension on your subscription, please{' '}
      <span className={styles.link}>contact us</span>.
    </p>
  </section>
);

export default SubscriptionInfo;
